import { Plus } from "lucide-react";
import { Link, NavLink } from "react-router";
import { cn, Logo } from "../ui";
import { fullNav, settingsNav } from "./navItems";
import { SyncIndicator } from "./SyncIndicator";

/** Touch-wide (720–1023px) icon rail with a Quick Add button (SPEC §11.2). */
export function Rail() {
  const items = [
    ...fullNav,
    { to: "/accounts", label: "Accounts", icon: fullNav[0]!.icon },
    settingsNav,
  ];
  return (
    <nav
      aria-label="Main"
      className="sticky top-0 flex h-dvh w-[84px] shrink-0 flex-col items-center gap-2 bg-chip py-4"
    >
      <Logo />
      <Link
        to="/add"
        aria-label="Add transaction"
        className="my-2 grid size-14 place-items-center rounded-[18px] bg-accent text-white shadow-raised"
      >
        <Plus size={26} strokeWidth={2.6} aria-hidden />
      </Link>
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              "flex min-h-12 w-[72px] flex-col items-center justify-center gap-0.5 rounded-xl text-[11.5px] font-bold text-muted no-underline",
              isActive && "bg-surface text-accent-strong shadow-soft",
            )
          }
        >
          <Icon size={22} strokeWidth={2.2} aria-hidden />
          {label}
        </NavLink>
      ))}
      <SyncIndicator className="mt-auto px-1 text-center text-[11px]" />
    </nav>
  );
}
